/*eslint-disable*/
import ENVS from './env'

const USA = { label: 'USA', value: 'US' };

//const FRANCE = { label: 'France', value: 'FR' };

export const COUNTRIES = [USA];

const ENGLISH_LOCALE = { label: 'en-US', value: 'en-US' }

export const LOCALES = [ENGLISH_LOCALE]

// export const DEV_DOMAIN_NAMES = [
//   { label: 'J&J', value: 'dev.login.jnj.com' },
// { label: 'MedTech', value: 'dev.login.jnjmedtech.com' }
// ]

const selectedTenant = localStorage.getItem('tenant');
export const DEV_DOMAIN_NAMES = selectedTenant === 'GlobalInnovMed' 
  ? [{ label:'J&J Innovative Medicine', value: 'dev.phm.id.jnj.com'}]
  : [
    { label: 'J&J', value: 'dev.login.jnj.com' },
    { label: 'MedTech', value: 'dev.login.jnjmedtech.com' },
  ];

export const STAGE_DOMAIN_NAMES = selectedTenant === 'GlobalInnovMed'
  ? [{ label:'J&J Innovative Medicine', value: 'stg.phm.id.jnj.com'}]
  : [
  { label: 'J&J', value: 'stg.login.jnj.com' },
  { label: 'Acuvue', value: 'stg.login.acuvue.com' },
  { label: 'MedTech', value: 'stg.login.jnjmedtech.com' },
  { label: 'J&J Innovative Medicine', value: 'stg.login.im.jnj.com' },
  { label: 'J&J withMe', value: 'stg.login.jnjwithme.com' }
]

export const PRODUCTION_DOMAIN_NAMES = selectedTenant === 'GlobalInnovMed'
  ? [{ label:'J&J Innovative Medicine', value: 'phm-id-jnj.okta.com'}]
  : [
  { label: 'J&J', value: 'login.jnj.com' },
  { label: 'Acuvue', value: 'login.acuvue.com' },
  { label: 'MedTech', value: 'login.jnjmedtech.com' },
  { label: 'J&J Innovative Medicine', value: 'login.im.jnj.com' },
  { label: 'J&J withMe', value: 'login.jnjwithme.com' }
]

export const DOMAIN_NAMES_BY_ENV = {
  [ENVS.DEV]: DEV_DOMAIN_NAMES,
  [ENVS.STAGE]: STAGE_DOMAIN_NAMES,
  [ENVS.PRODUCTION]: PRODUCTION_DOMAIN_NAMES,
}

export const ENV_LABELS_BY_ENV = {
  [ENVS.DEV]: 'Dev Environment',
  [ENVS.STAGE]: 'Stage Environment',
  [ENVS.PRODUCTION]: 'Prod Environment',
}

export const EMPTY_PLACE_HOLDER = '-'